// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1d187e07","156":"1099ab86","431":"70573561","489":"c152ecd7","492":"b07a6dfe","608":"052bdf40"}[chunkId] + ".chunk.js";
};